import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { usePartnerOperations } from '../context/PartnerOperationsContext';

const PartnerOperationsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerOperations();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-center">{t('Nr')}</th>
        <th className="tnk-tb-col text-left" />
        <th className="nk-tb-col text-left"> {t('Type')}</th>
        <th className="nk-tb-col text-center">{t('Date')}</th>
        <th className="nk-tb-col tb-col-xl text-right">{t('Amount')}</th>
        <th className="nk-tb-col tb-col-xl text-right">{t('Premium')}</th>
        <th className="nk-tb-col text-right">{t('NrPart.')}</th>
        <th className="nk-tb-col tb-col-xl text-center">{t('Class')}</th>
        <th className="nk-tb-col tb-col-xl text-right">{t('From')}</th>
        <th className="nk-tb-col tb-col-xl text-right">{t('To')}</th>
        <th className="nk-tb-col tb-col-xl text-left">{t('Doc.')}</th>
        {data.hasTitlesEnabled && (
          <th className="nk-tb-col text-left">{t('Title')}</th>
        )}
      </tr>
    </thead>
  );
};

export default PartnerOperationsTableHeader;
